import { useState, useCallback, useEffect } from "react";
import employeeLeaveBalanceService from "../services/employeeLeaveBalanceService";

export const useEmployeeLeaveBalance = ({
  employeePersonalInformationId, 
  showGeneralMessage
}) => {
  const [loading, setLoading] = useState(false);
  const [employeeLeaveCredits, setEmployeeLeaveCredits] = useState([]);
  const [isLockedByYear, setIsLockedByYear] = useState(false);
  const [currentYearDisplay, setCurrentYearDisplay] = useState(null); // MODIFIED: For display only
  const [selectedEmployeeLeaveCredit, setSelectedEmployeeLeaveCredit] = useState(null);

  const fetchData = useCallback(async () => {
    if (!employeePersonalInformationId) return;
    
    setLoading(true);
    try {
      const res = await employeeLeaveBalanceService.getByEmployee(employeePersonalInformationId);

      const credits = res.data.allData || [];
      const locked = res.data.isLockedByYear || false;

      setEmployeeLeaveCredits(credits);
      setIsLockedByYear(locked);
      
      if (credits.length > 0) {
        setCurrentYearDisplay(credits[0].currentYearReference);
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Failed to load leave balances";
      showGeneralMessage(errorMsg, false);
      setCurrentYearDisplay(null);
    } finally {
      setLoading(false);
    }
  }, [employeePersonalInformationId, showGeneralMessage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const updateLocalBalance = (leaveTypeId, field, value) => {
    setEmployeeLeaveCredits(prev => prev.map(item =>
      item.leaveTypeId === leaveTypeId ? { ...item, [field]: value } : item
    ));
  };

  const executeSave = async (formData) => {
    // Note: No more local year injection. Backend handles it.
    try {
      const { currentYearReference, ...payload } = formData; // MODIFIED: Clean payload

      if (!formData.id || formData.id === 0) {
        await employeeLeaveBalanceService.create(payload);
      } else {
        await employeeLeaveBalanceService.update(formData.id, payload);
      }
      showGeneralMessage("Leave Credit/s updated successfully", true);
      fetchData(); 
    } catch (err) {
      const errorMsg = err.response?.data?.message || "An error occurred";
      showGeneralMessage(errorMsg, false);
    }
  };

  return {
    loading,
    employeeLeaveCredits,
    currentYear: currentYearDisplay, // Exported for UI Tooltips
    isLockedByYear,
    selectedEmployeeLeaveCredit, 
    setSelectedEmployeeLeaveCredit,
    updateLocalBalance,
    executeSave,
    fetchBalances: fetchData
  };
};